export const defaultCreateContractValues = {
  expenditureFromVNU: 0,
  fixedExpenditure: 0,
  flexibleExpenditure: 0,
  expenditureFromFunding: 0,
  totalExpenditure: 0,
  projectCode: null,
  startDate: null,
  endDate: null,
  fileUrl: null,
  // projectAppendixes: [],
  appendixFiles: [],
  projectAppendixDeletedFileIds: [],
  // numberMonthImplementation: null,
};
export const fieldsInputForm = [
  'expenditureFromVNU',
  'fixedExpenditure',
  'flexibleExpenditure',
  'expenditureFromFunding',
  'totalExpenditure',
  'projectCode',
  'startDate',
  'endDate',
  'fileUrl',
];

export const defaultLiquidationValues = {
  appendixFiles: [],
};

export const defaultDetailContractValues = {};

export const defaultFinancialAdjustment = {
  commitment: '',
  otherExpenditure: 0,
  financialAdjustmentItems: [],
};

export const defaultFinancialAdjustmentItem = {
  name: '',
  expenditureTypeId: '',
  beforeExpenditureFromVNUHCM: 0,
  beforeExpenditureFromFunding: 0,
  afterExpenditureFromVNUHCM: 0,
  afterExpenditureFromFunding: 0,
  reason: '',
};
